// src/modules/app-views/invoices/pages/Init/components/tableColumns/recipientColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import translateX from 'utils/translateX';
import { isCpfOrCnpj, parseCnpjToDisplay, parseCpfToDisplay } from 'utils/helpers';

const { Text } = Typography;

// *******************************************************************************
// GLOBAL VARIABLES
// *******************************************************************************

const blockStyle = { display: 'block' };
const subtitleStyle = { fontSize: 12 };

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Invoices-only recipient column.
// Shows recipient name + CPF/CNPJ subtitle.
function recipientColumn(buildColumnProps) {
  return {
    title: translateX('recipient'),
    dataIndex: ['recipient', 'name'],
    ...buildColumnProps('recipient.name', { sort: true }),
    ellipsis: true,
    render: (_, record) => {
      const recipient = record?.recipient;
      const recipientEntity = record?.recipientEntity;
      const name = recipientEntity?.fullName || recipient?.name || translateX('consumer');
      const isFinalConsumer =
        record?.isFinalConsumer ||
        recipientEntity?.finalConsumer ||
        recipientEntity?.genericPerson ||
        recipientEntity?.genericCompany;

      const cpfCnpj =
        recipient?.cpfCnpj || recipientEntity?.cpf?.value || recipientEntity?.cnpj?.value;
      const cpfCnpjWithLabel = cpfCnpj
        ? isCpfOrCnpj(cpfCnpj) === 'cpf'
          ? `CPF: ${parseCpfToDisplay(cpfCnpj)} `
          : `CNPJ: ${parseCnpjToDisplay(cpfCnpj)}`
        : null;

      const legacyCode = recipient?.legacyCode;
      const subtitleParts = [];
      if (cpfCnpjWithLabel) subtitleParts.push(cpfCnpjWithLabel);
      if (legacyCode?.length > 0) {
        const lcValue = Array.isArray(legacyCode) ? legacyCode.join(',') : legacyCode;
        subtitleParts.push(`LC: ${lcValue}`);
      }
      const subtitle = subtitleParts.join(' | ');

      return (
        <div>
          <Text type={isFinalConsumer ? 'secondary' : ''} ellipsis strong style={blockStyle}>
            {name}
          </Text>
          {subtitle && (
            <Text type="secondary" style={subtitleStyle}>
              {subtitle}
            </Text>
          )}
        </div>
      );
    },
  };
}

export default recipientColumn;
